// Reasonable upper bound: ~25 min/km (~5km in 2h) — anything beyond is sensor noise.
const MAX_PACE_SEC = 25 * 60;

export function formatPace(secPerKm) {
  if (!secPerKm || secPerKm <= 0 || !Number.isFinite(secPerKm) || secPerKm > MAX_PACE_SEC) return '--:--';
  const m = Math.floor(secPerKm / 60);
  const s = Math.floor(secPerKm % 60);
  return `${m}:${String(s).padStart(2, '0')}`;
}

// Convenience: compute pace from total seconds + total km, return formatted string.
// Returns '--:--' when distance is too small to be meaningful (< 50m).
export function computePace(totalSec, distanceKm) {
  if (!distanceKm || distanceKm < 0.05 || !totalSec) return '--:--';
  return formatPace(Math.floor(totalSec / distanceKm));
}

// Countdown to an ISO datetime — returns { days, hours, minutes, label, isSoon, isPast }
// `isSoon` is true when the event is within 24 hours.
export function countdownTo(iso) {
  if (!iso) return null;
  const target = new Date(iso).getTime();
  const now = Date.now();
  const diff = target - now;
  if (diff <= 0) return { days: 0, hours: 0, minutes: 0, label: 'Started', isSoon: false, isPast: true };
  const days = Math.floor(diff / 86400000);
  const hours = Math.floor((diff % 86400000) / 3600000);
  const minutes = Math.floor((diff % 3600000) / 60000);
  let label;
  if (days >= 1) label = `${days}d ${hours}h`;
  else if (hours >= 1) label = `${hours}h ${minutes}m`;
  else label = `${minutes}m`;
  return { days, hours, minutes, label, isSoon: diff < 86400000, isPast: false };
}

export function formatDuration(totalSec) {
  if (totalSec == null) return '00:00';
  const h = Math.floor(totalSec / 3600);
  const m = Math.floor((totalSec % 3600) / 60);
  const s = Math.floor(totalSec % 60);
  if (h > 0) return `${h}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
  return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
}

export function formatDistance(km) {
  if (km == null) return '0.00';
  return km.toFixed(2);
}

export function formatEventDate(iso) {
  const d = new Date(iso);
  return d.toLocaleDateString('en-NG', { day: '2-digit', month: 'short', year: 'numeric' });
}

export function formatEventTime(iso) {
  const d = new Date(iso);
  return d.toLocaleTimeString('en-NG', { hour: '2-digit', minute: '2-digit' });
}

export function daysUntil(iso) {
  const target = new Date(iso).getTime();
  const now = Date.now();
  const diff = Math.ceil((target - now) / (1000 * 60 * 60 * 24));
  return diff;
}
